import React, { useState, useEffect } from "react";
import CompareProductTable from '../ProductCompare/CompareProductTable';
import ProductCompareMiniSlider from "../ProductCompare/BottomCompareProduct/ProductCompareMiniSlider";
import { __set } from 'src/store/axios_indicator';
import useReduxState from 'src/hooks/useReduxState';
import alertic from 'src/assets/images/yellow-alert.png';
import ShowAlert from "src/component/Global/ShowAlert";
import Helper from "src/helper/Helper";
import { isArray, isObject } from 'underscore';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { useProductStore } from 'src/hooks/product';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Export from 'src/helper/export';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import exportProductCompareDataToXLS from "../ProductCompare/exportProductCompareDataToXLS";
import ProductCompareClearAll from "../ProductCompare/ProductCompareClearAll";
import RefreshStockButton from "../ProductListing/RefreshStockButton";
import { Tooltip } from "src/component/Global/Tooltip";

export function ProductCompare() {
  const [showError, setShowError] = useState(false)
  const [showNoProductError, setNoProductError] = useReduxState(false, 'setNoProductError');
  const [{ model_ProductCompare_data }, { }, { }] = useProductStore()
  const [{ CART_BEFORE_TO_SEND_SERVER }] = useCartStore();
  const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [__check] = useAxiosIndicatorCheck();
  useEffect(() => {
    __set('PRODUCT_COMPARE_API_CALL');
    Helper.feedBackButtonScript()
  }, [])

  const showDownloadMessage = () => {
    system_alert_indicator({
      name: 'exportMsgForListing',
      message: Constants.downloadMsg,
      type: "success"
    })
  }

  const getPriceText = (price, isPrice = false) => {
    if (price && price.quantity && price.quantity > -1 && price.marketPrice &&
      price.marketPrice > -1) {
      if (isPrice) {
        return System.getFormatNumber({ amount: Number(price.marketPrice), isDisplaySymbol: false })
      }
      return System.getFormatNumber({ amount: Number(price.marketPrice), isDisplaySymbol: false });
    }
    return '';
  }

  const exportData = async () => {
    const final_Export_Data = [];
    const key_list_to_export = new exportProductCompareDataToXLS()
    Object.entries(model_ProductCompare_data).map(async (single_product) => {
      const single_final_product = {};
      Object.entries(key_list_to_export).map((s) => {
        const key_list_to_export_field_list = s[0];
        if (key_list_to_export_field_list === "CustomerPartNumbers") {
          single_final_product[s[1]] = CART_BEFORE_TO_SEND_SERVER[single_product[1].ItemNumber]?.CPN;
        } else if (single_product[1][s[1]]) {
          single_final_product[key_list_to_export_field_list] = single_product[1][s[1]] || '';
        }
      });
      let quantity = CART_BEFORE_TO_SEND_SERVER[single_product[0]]?.quantityUpdateToCart || "";

      single_final_product.Min = single_product[1]?.QtyMin;
      single_final_product.Mult = single_product[1]?.QtyMult;
      single_final_product.Quantity = quantity;
      single_final_product.Availability = get_inventory_by_id(single_product[1].ItemNumber)?.inventoryQty;
      const price = get_pricing_by_id({
        ItemNumber: single_product[1].ItemNumber
      });
      const isCustomerPrice = System.checkIsCustomerPrice(price);
      Helper.rangToArray(1, price.length).map((v) => {
        single_final_product['Tier ' + v + ' - Quantity'] = 'Tier ' + v + ' - Quantity'
        single_final_product['Tier ' + v + ' - Price'] = 'Tier ' + v + ' - Price'

        single_final_product['Tier ' + v + ' - Quantity'] = '';
        single_final_product['Tier ' + v + ' - Price'] = '';

        if (!isCustomerPrice && price[v - 1] && price[v - 1].quantity && price[v - 1].quantity > 0) {
          single_final_product['Tier ' + v + ' - Quantity'] = `${price[v - 1].quantity}+`;
        }
        if (price[v - 1] && price[v - 1].marketPrice > 0) {
          single_final_product['Tier ' + v + ' - Price'] = getPriceText(price[v - 1]);
        }
      });
     final_Export_Data.push(single_final_product);
    });

    const f = [];
    await Promise.all(Object.entries(final_Export_Data).map((v, key) => {
      if (Object.entries(v[1]).length > 0) {
        Object.keys(v[1]).map((key, i) => {
          if (v[1][key] === '' || v[1][key] === 0 || v[1][key] === null || (isObject(v[1][key]) && Object.entries(v[1][key]).length <= 0) || (isArray(v[1][key]) && v[1][key].length <= 0) || v[1][key] === undefined) {
            v[1][key] = ''
          }
        })
      }
      f.push(v[1]);
    }));

    if (f.length > 0) {
      Export.toExcel(f, 'EXPORT_COMPARE_PAGE')
      showDownloadMessage();
    }
  };

  const renderTooltip = (props) => (
    <>
      <RefreshStockButton label={'Availability Refresh'} />
      <br />
      Refresh the product availability to a real time call.
    </>
  );

  const openEmailPopup = () => {
    System.popup('SendEmailOfCurrentPage')
  }
  return (
    <>
      <div>
        <div className="copmare-product-page">
          <ShowAlert doNotShow={['productCompare']} />
          {showError && !showNoProductError &&
            <div className="container">
              <div className="row mt-2">
                <div className={'col-lg-12 p-0'}>
                  <div className="alert alert-warning fade in font-16 mb-2">
                    <span>Be aware that the products selected do not have the same technical characteristics so may not be directly comparable.</span>
                    <img className="ms-auto" src={alertic} alt="Alert icon" />                    </div>
                </div>
              </div>
            </div>
          }
          <div className="container-fluid maxw100">
            <div className="bs5 row">
              <div className="col-12">
                <a
                  href={void 0}
                  className="back-btn"
                  onClick={() => history.back()}
                >
                  <i className="fa fa-angle-left" /> BACK TO PRODUCTS
                </a>              </div>
            </div>
            <div className="bs5 row">
              <div className="col-12">
                <h3>Compare Products</h3>
              </div>
            </div>

            <>
              <div className="table-area-actions d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  <div className="add-clear-btn">
                    {Object.entries(model_ProductCompare_data).length < 10 && (
                      <button
                        className="bs5 btn btn-secondary m-1"
                        onClick={() => {
                          history.back();
                        }}
                      >
                        ADD PART
                      </button>
                    )}
                    {Object.entries(model_ProductCompare_data).length > 0 && (
                      <ProductCompareClearAll type="button" />
                    )}
                    <a href={void 0} className="compare-clear-link">
                      {
                        __check(
                          [
                            "PRODUCT_COMPARE_API_CALL",
                            "PRODUCT_INVENTORY_API_CALL",
                            "CART_API_CALL",
                          ],
                          { inline: true }
                        ).render
                      }
                    </a>
                  </div>
                </div>
                {Object.entries(model_ProductCompare_data).length > 0 &&
                  <div className="table-area-actions-right ">
                    <div className="table-area-actions-buttons me-0">
                      <Tooltip opener={() => (
                        <button className="bs5 btn btn-secondary" style={{ cursor: 'auto' }}>
                          <i className="fa fa-info-circle text-darkgreen me-2" aria-hidden="true" />
                          TOOLTIP
                        </button>)}
                        content={() => (
                          renderTooltip()
                        )}
                      />
                      <button style={{ cursor: 'pointer' }} onClick={openEmailPopup}
                        className="bs5 btn btn-secondary">Email
                      </button>
                      <button style={{ cursor: 'pointer' }} onClick={exportData}
                        className="bs5 btn btn-secondary">Download
                      </button>
                    </div>
                  </div>
                }            </div>
            </>

            {showNoProductError ?
              <div className='text-center'>
                <ShowAlert onlyShowMessage={['productCompare']} />
              </div>
              :

              <CompareProductTable setShowError={setShowError} setNoProductError={setNoProductError} />
            }
          </div>
        </div>

      </div>
      <ProductCompareMiniSlider hideCompareSlider={true} />
    </>
  );

}
